// Centralized media mime types and helpers for uploaders
export const IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/jpg',
  'image/gif',
  'image/bmp',
  'image/svg',
  'image/svg+xml',
];

export const VIDEO_MIME_TYPES = [
  'video/mp4',
  'video/quicktime', // .mov
  'video/webm',
  'video/x-m4v',
];

export const MEDIA_MIME_TYPES = [...IMAGE_MIME_TYPES, ...VIDEO_MIME_TYPES];

export const IMAGE_EXTS = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.bmp', '.svg'];
export const VIDEO_EXTS = ['.mp4', '.mov', '.webm', '.m4v'];
export const MEDIA_ACCEPT_EXT = [...IMAGE_EXTS, ...VIDEO_EXTS].join(',');
export const IMAGE_ACCEPT_EXT = IMAGE_EXTS.join(',');
export const VIDEO_ACCEPT_EXT = VIDEO_EXTS.join(',');

export const isImageMime = (type: string): boolean => IMAGE_MIME_TYPES.includes(type);
export const isVideoMime = (type: string): boolean => VIDEO_MIME_TYPES.includes(type);
export const isAcceptedMediaMime = (type: string): boolean => MEDIA_MIME_TYPES.includes(type);

export const DEFAULT_IMAGE_MAX_MB = 50;
export const DEFAULT_VIDEO_MAX_MB = 199;

export const validateMediaSizeMB = (sizeBytes: number, type: string): boolean => {
  const max = isVideoMime(type) ? DEFAULT_VIDEO_MAX_MB : DEFAULT_IMAGE_MAX_MB;
  return sizeBytes / 1024 / 1024 < max;
};

export const mediaSupportDescription = (
  imageMaxMB: number = DEFAULT_IMAGE_MAX_MB,
  videoMaxMB: number = DEFAULT_VIDEO_MAX_MB,
): string =>
  `Supports: Images (${IMAGE_EXTS.join(', ')}) and Videos (${VIDEO_EXTS.join(', ')}). Max size: images ${imageMaxMB} MB, videos ${videoMaxMB} MB.`;

export const mediaAllowedTypesMessage = (): string =>
  `Allowed: images (${IMAGE_EXTS.join(', ')}) or videos (${VIDEO_EXTS.join(', ')}).`;

export const imageSupportDescription = (imageMaxMB: number = DEFAULT_IMAGE_MAX_MB): string =>
  `Supports: Images (${IMAGE_EXTS.join(', ')}). Max size: ${imageMaxMB} MB.`;

export const videoSupportDescription = (videoMaxMB: number = DEFAULT_VIDEO_MAX_MB): string =>
  `Supports: Videos (${VIDEO_EXTS.join(', ')}). Max size: ${videoMaxMB} MB.`;

export const imageAllowedTypesMessage = (): string =>
  `Allowed image formats: ${IMAGE_EXTS.join(', ')}`;

export const videoAllowedTypesMessage = (): string =>
  `Allowed video formats: ${VIDEO_EXTS.join(', ')}`;

const formatExtsShort = (exts: string[]): string => exts.map((e) => e.replace('.', '')).join(', ');

export const imageShortDescription = (imageMaxMB: number = DEFAULT_IMAGE_MAX_MB): string =>
  `${formatExtsShort(IMAGE_EXTS)}. Max ${imageMaxMB} MB`;

export const videoShortDescription = (videoMaxMB: number = DEFAULT_VIDEO_MAX_MB): string =>
  `${formatExtsShort(VIDEO_EXTS)}. Max ${videoMaxMB} MB`;
